import React, {useState, useEffect} from 'react'
import {Table, Button, Input, Modal, Spin, Row, Col, Tooltip, Icon} from 'antd'
import {EditOutlined, SearchOutlined} from '@ant-design/icons'
import Layouts from '../../components/Layouts'
import RoleForm from './AddEditRole'
import apiRequest from '../../hooks/ApiRequest'
import hasPermissions from '../../hooks/Permissions'
import CommonSearch from '../../hooks/Search'
const RoleList = () => {
  const [nationalID, setNationalID] = useState('')
  const [baseData, setBaseData] = useState([])
  const [loading, setLoading] = useState(false)
  const [modalVisible, setModalVisible] = useState(false)
  const [selectedRoleId, setSelectedRoleId] = useState(null)
  const [rolePermissions, setRolePermissions] = useState({})

  useEffect(() => {
    setRolePermissions(hasPermissions('Roleclaims'))

    fetchRoles()
  }, [])

  const fetchRoles = async () => {
    setLoading(true)
    try {
      const response = await apiRequest(
        process.env.REACT_APP_BASE_URL_AUTH + '/api/RoleClaimManager/roles',
        'GET',
      )
      setBaseData(response?.data)
    } catch (error) {
      console.error('Error fetching roles', error)
    } finally {
      setLoading(false)
    }
  }

  const handleSearch = value => {
    const filterTable = baseData.filter(o =>
      String(o.roleName || '')
        .toLowerCase()
        .includes(value.toLowerCase().trim()),
    )
    setBaseData(filterTable)
  }
  const ClearSerach = () => {
    setNationalID('')
    setBaseData(baseData)
    fetchRoles()
  }
  const handleCreateRole = () => {
    setSelectedRoleId(null)
    setModalVisible(true)
  }

  const handleEditRole = roleId => {
    setSelectedRoleId(roleId)
    setModalVisible(true)
  }

  const handleModalClose = () => {
    setModalVisible(false)
    fetchRoles()
  }

  const columns = [
    {title: 'Role Name', dataIndex: 'roleName', key: 'roleName'},
    ...(rolePermissions.hasOwnProperty('12') &&
    rolePermissions.hasOwnProperty('11')
      ? [
          {
            title: 'Actions',
            key: 'actions',
            render: (_, record) => (
              <Tooltip title="Edit">
                <Button
                  type="primary"
                  className="edit_btn"
                  onClick={() => handleEditRole(record?.id)}>
                  <EditOutlined />
                </Button>
              </Tooltip>
            ),
          },
        ]
      : []),
  ]


  return (
    <div title="assets" className="ant-layout-content dashboard">
      <div className="dash-bg-white">
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={24} md={24} lg={12}>
            <div className="section-top-heading">
              <h3
                style={{
                  color: '#0C1362',
                  fontWeight: '600',
                  fontSize: '20px',
                }}>
                ROLES AND PERMISSIONS
              </h3>
            </div>
          </Col>
          <Col xs={24} sm={24} md={24} lg={7}>
            <div className="item-search">
              <CommonSearch
                value={nationalID}
                onChange={e => setNationalID(e.target.value)}
                onSearch={handleSearch}
                onClear={ClearSerach}
              />
            </div>
          </Col>
          <Col xs={24} sm={24} md={3} lg={2}>
            <div className="create-quotation">
              <Button
                type="primary"
                onClick={() => handleSearch(nationalID)}
                style={{marginLeft: 10}}>
                Search
              </Button>
            </div>
          </Col>
        </Row>
      </div>

      {loading ? (
        <Spin
          className="loader-icon-fixed"
          size="large"
          style={{display: 'block', marginTop: 20}}
        />
      ) : (
        <Table columns={columns} dataSource={baseData} rowKey="id" />
      )}

      {/* RoleForm Modal */}
      <Modal
        title={selectedRoleId ? 'Edit Role' : 'Add Role'}
        centered
        visible={modalVisible}
        footer={null}
        onCancel={() => setModalVisible(false)}
        width={760}>
        <RoleForm
          roleId={selectedRoleId}
          onSuccess={handleModalClose}
          modalVisible={modalVisible}
        />
      </Modal>
    </div>
  )
}

export default RoleList
